function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.00027 15.4C9.69766 15.401 11.3259 14.7276 12.5268 13.528C13.7277 12.3285 14.4029 10.701 14.4038 9.00359C14.4048 7.3062 13.7314 5.67796 12.5319 4.47706C11.3323 3.27615 9.70481 2.60096 8.00742 2.60001C6.31004 2.59906 4.68179 3.27244 3.48089 4.472C2.27999 5.67156 1.60479 7.29905 1.60385 8.99643C1.6029 10.6938 2.27627 12.3221 3.47583 13.523C4.6754 14.7239 6.30288 15.3991 8.00027 15.4ZM5.60429 8.19867L4.00429 8.19778L4.0034 9.79778L5.6034 9.79867L5.60429 8.19867ZM12.0043 8.20224L10.4043 8.20135L10.4034 9.80135L12.0034 9.80224L12.0043 8.20224ZM7.20429 8.19956L8.80429 8.20046L8.8034 9.80046L7.2034 9.79956L7.20429 8.19956Z",
  fill: "currentColor"
});

function SvgThreeDotsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.5f0a59d9.svg";
export { ForwardRef as ReactComponent };